import type { WidgetType } from '@safetyhub/shared';

/**
 * 위젯 종류 전환 공용 — **combobox로 처음 전환될 때 '제안에서만 선택'(requireSelection)을 기본
 * 활성으로 시드**한다(2026-08-24 사용자 확정: 콤보 기본값 = 선택 전용, 자유 입력은 명시적 해제).
 * 저작 시점 시드일 뿐이라 기존 템플릿 저장값·이미 combobox인 위젯은 불변이다. 해제는 체크박스가
 * **명시적 `false`로 저장**한다(키 삭제가 아님 — 삭제하면 combobox↔타 위젯 왕복 시
 * `=== undefined` 시드 조건이 다시 참이 되어 꺼둔 값이 true로 재시드된다. 미설정(신규 전환 시드
 * 대상)과 명시 해제를 값으로 구분. rc는 `=== true`만 보므로 false 저장은 렌더에 무영향이고,
 * 키 부재인 기존 템플릿 하위호환도 그대로다). 세 전환 지점(트리 속성창·formTable 셀·일괄 변경)이
 * 공유. EditorPage에서 분리(2026-08-24 W8) — 시드·해제 짝 규약을 단위 spec으로 고정하기 위함.
 */
export function withWidgetTypeChange<T extends object>(x: T, widget: WidgetType): T {
  // 호출부는 전부 input 위젯 렌더 분기 안이지만 파라미터 타입이 union(ComposerWidget 등)이라
  // 구조적으로 읽는다 — input 외 kind에는 이 select 자체가 안 뜬다.
  const cur = x as { widget?: WidgetType; requireSelection?: boolean };
  if (widget === 'combobox' && cur.widget !== 'combobox' && cur.requireSelection === undefined) {
    return { ...x, widget, requireSelection: true } as T;
  }
  return { ...x, widget } as T;
}
